import { put, call, fork, all, takeLatest, select } from "redux-saga/effects";
import * as dateAndSpecialistTypes from "~/store/dateAndSpecialist/dateAndSpecialistTypes";
import * as apiDateAndSpecialist from "~/store/dateAndSpecialist/dateAndSpecialistAPI";
import { getBaseUrl } from "~/utils/getBaseUrl";

/* choose hospital list */
function* requestSpecialistByHospital() {
  try {
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const hospitalId = yield select(
      state => state.hospital.selectedHospital.id
    );
    const { info } = yield select(state => state.user);
    const response = yield call(
      apiDateAndSpecialist.apiRequestSpecialistByHospital,
      baseUrl,
      info,
      hospitalId
    );
    const {
      data: { data }
    } = response;
    yield put({
      type: dateAndSpecialistTypes.REQUEST_SPECIALIST_BY_HOSPITAL_SUCCESS,
      data
    });
  } catch (error) {
    yield put({
      type: dateAndSpecialistTypes.REQUEST_SPECIALIST_BY_HOSPITAL_FAIL,
      error
    });
  }
}

function* watchRequestSpecialistByHospital() {
  yield takeLatest(
    dateAndSpecialistTypes.REQUEST_SPECIALIST_BY_HOSPITAL,
    requestSpecialistByHospital
  );
}

export default function* root() {
  yield all([fork(watchRequestSpecialistByHospital)]);
}
